import {
  BaseGameActivityEntity,
  CurrencyType,
  getCurrencyConfig,
  getPlatformFeeRate,
} from '@okletsplay/core';
import { DEFAULT_GAME_ACTIVITY_PAYMENT_CONFIG } from '../constants';
import { ExchangeRateDto } from 'app/interfaces/dto';
import { selectExchangeRate } from 'shared/utils';
import { GameActivityPaymentConfig } from '../interfaces';
import { cloneDeep } from 'lodash';

type ParametersType = {
  gameActivity: BaseGameActivityEntity | undefined;
  exchangeRates: ExchangeRateDto[];
};

export const buildGameActivityPaymentConfig = ({
  gameActivity,
  exchangeRates,
}: ParametersType): GameActivityPaymentConfig => {
  const currencyType = gameActivity?.currencyType;

  const paymentConfig = cloneDeep(DEFAULT_GAME_ACTIVITY_PAYMENT_CONFIG);
  if (currencyType) {
    const currencyConfig = getCurrencyConfig(currencyType);
    paymentConfig.currencyType = currencyType;

    if (currencyConfig?.main) {
      paymentConfig.mainCurrency = currencyConfig?.main;
    }

    if (currencyConfig?.platformFee) {
      paymentConfig.platformFeeCurrency = currencyConfig?.platformFee;
    }
  }

  switch (currencyType) {
    case CurrencyType.OKLP:
      paymentConfig.isPlatformFeeApplied = false;
      break;
    case CurrencyType.USDT_OKLP:
    case CurrencyType.USDT_USDT:
      paymentConfig.isPlatformFeeApplied = true;
      break;
  }

  if (exchangeRates?.length && currencyType) {
    const exchangeRateName = getPlatformFeeRate(currencyType);
    if (exchangeRateName) {
      paymentConfig.exchangeRate = selectExchangeRate(exchangeRates, exchangeRateName);
    }
  }

  return paymentConfig;
};
